export const getActiveElement = () => {
    const host = document.querySelector(`#${SHADOW_DOM_ROOT_ID}`);

    return host?.shadowRoot ? host.shadowRoot.activeElement : document.activeElement;
};
